import React from "react";
import { useIntl } from "react-intl";
import useDispatchSnackbar from "./useDispatchSnackbar";
import { Box } from "@mui/material";

export default function useCopyToClipboard(copyText, completeCopiedText) {
  const dispatchSnackbar = useDispatchSnackbar();
  const { formatMessage } = useIntl();

  const copyFn = (needCopyText = null) => {
    const textToCopy =
      typeof needCopyText === "string" ? needCopyText : copyText;
    navigator.clipboard.writeText(textToCopy);
    dispatchSnackbar({
      message:
        completeCopiedText ||
        formatMessage({
          id: "global.status.copied",
        }),
      variant: "success",
    });
  };

  return copyFn;
}
